import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

function Trichy() {
    const [openFaq, setOpenFaq] = useState(null);
    const navigate = useNavigate();

    const faqs = [
        {
            q: "How can I book a self drive car in Trichy with Wow carz?",
            a: "Booking is simple: visit the website or app, choose your car, select a package (hourly/daily/weekly or 100 km trip), and confirm. You'll receive a booking confirmation and pickup details.",
        },
        {
            q: "What documents are required to rent a car in Trichy?",
            a: "You need a valid driving license (minimum age 21 and at least 1 year of driving history) and a government-issued ID (Aadhar or Passport).",
        },
        {
            q: "Can I rent a car for a short trip within the city?",
            a: "Yes — Wow carz offers hourly, daily and monthly packages suitable for city travel, shopping, meetings, and short outings.",
        },
        {
            q: "Is it possible to take the rental car outside Trichy?",
            a: "Yes — choose the appropriate outstation package to drive to nearby destinations like Nandi Hills, Mysore, Coorg and more. Check package details for kilometer limits and charges.",
        },
        {
            q: "Why should I choose Wow carz over other car rental services in Trichy?",
            a: "Wow carz provides hassle-free booking, competitive pricing, well-maintained cars and 24/7 support — giving you freedom to travel at your own pace.",
        },
        {
            q: "Are Wow carz rentals available for both short and long durations?",
            a: "Yes — you can book hourly packages for short trips or daily/weekly rentals for long trips and weekend getaways.",
        },
    ];

    const places = [
        {
            image: "/assets/rockforttemple.jpg",
            title: "Rockfort Temple",
            desc: "One of the most famous landmarks in Trichy, Rockfort Temple sits on a 273-foot rock and offers breathtaking views of the city after climbing the ancient steps.",
        },
        {
            image: "/assets/srirangamtemple.jpg",
            title: "Sri Ranganathaswamy Temple (Srirangam)",
            desc: "The largest functioning Hindu temple complex in the world, Srirangam Temple is dedicated to Lord Vishnu and attracts millions of pilgrims every year.",
        },
        {
            image: "/assets/jambukeswarartemple.jpg",
            title: "Jambukeswarar Temple",
            desc: "Located in Thiruvanaikaval, this temple is one of the Pancha Bhoota temples representing the element of water and is a must-visit spiritual destination.",
        },
        {
            image: "/assets/kallanai.jpg",
            title: "Kallanai Dam (Grand Anicut)",
            desc: "Built by the Chola king Karikalan over 2000 years ago, Kallanai is one of the oldest water-regulation structures still in use.",
        },
        {
            image: "/assets/samayapurammariamman.jpg",
            title: "Samayapuram Mariamman Temple",
            desc: "A famous temple dedicated to Goddess Mariamman, known for devotees seeking blessings for health and prosperity.",
        },
        {
            image: "/assets/mukkombu.jpg",
            title: "Mukkombu (Upper Anaicut)",
            desc: "A scenic picnic spot where the Kaveri river splits into two branches, surrounded by parks and beautiful river views.",
        },
    ];

    const nearplaces = [
        {
            image: "/assets/viralimalai.jpg",
            title: "Viralimalai Murugan Temple (30 km )",
            desc: "A famous hill temple dedicated to Lord Murugan, known for its peaceful surroundings and scenic hill views. It is a perfect spiritual trip from Trichy with your self drive car rental.",
        },
        {
            image: "/assets/puliyancholai.jpg",
            title: "Puliyancholai Falls (72 km )",
            desc: "A scenic waterfall located in the foothills of Kolli Hills. It is a great nature getaway near Trichy where visitors can enjoy fresh air, greenery, and a relaxing drive.",
        },
        {
            image: "/assets/thirumayamfort.jpg",
            title: "Thirumayam Fort (65 Km)",
            desc: "A historic 17th century fort located near Pudukkottai. The fort offers beautiful panoramic views and is a great place to explore history during your road trip from Trichy.",
        },
        {
            image: "/assets/kodumbalur.jpg",
            title: "Kodumbalur Moovar Koil (40 km )",
            desc: "A stunning Chola-era temple complex famous for its ancient architecture and stone sculptures. It is a must-visit heritage site for history lovers near Trichy.",
        },
        {
            image: "/assets/sittannavasal.jpg",
            title: "Sittannavasal Cave Temple (58 km)",
            desc: "A historic Jain cave temple famous for its ancient paintings and rock-cut architecture. This peaceful heritage site offers a unique cultural experience near Trichy.",
        },
    ];

    const whyCards = [
        {
            title: "Easy Booking in Trichy",
            text: "Book your self-drive car in Trichy within minutes and start your journey smoothly across the city or beyond.",
        },
        {
            title: "Safe & Well-Maintained Cars",
            text: "Our vehicles are regularly serviced and sanitized, ensuring a safe and comfortable drive around Trichy and Tamil Nadu.",
        },
        {
            title: "Flexible Rental Plans",
            text: "Choose hourly, daily, or outstation packages perfect for temple visits, business trips, or weekend getaways.",
        },
        {
            title: "Explore Trichy & Nearby Getaways",
            text: "Drive to Rockfort Temple, Srirangam, Thanjavur, or Kodaikanal with complete freedom and comfort.",
        },
        {
            title: "Airport & Railway Station Pickup",
            text: "Convenient car delivery at Trichy Airport, railway station, or your doorstep – anytime you need.",
        },
    ];

    // Slider settings
    const sliderSettings = {
        dots: true,
        infinite: true,
        speed: 500,
        autoplay: true,
        autoplaySpeed: 2500,
        slidesToShow: 3,
        slidesToScroll: 1,
        responsive: [
            {
                breakpoint: 1024,
                settings: { slidesToShow: 2 },
            },
            {
                breakpoint: 768,
                settings: { slidesToShow: 1, arrows: false },
            },
        ],
    };

    return (
        <div className="min-h-screen bg-gray-50 text-gray-800 font-inter">
            {/* Header */}
            <header className="bg-blue-100 shadow-sm sticky top-0 z-20">
                <div className="max-w-8xl mx-auto px-4 sm:px-6 lg:px-8 py-2 flex items-center justify-between">
                    <div className="flex-shrink-0">
                        <img
                            onClick={() => navigate("/")}
                            loading="lazy"
                            style={{ height: 55, width: 160 }}
                            src="https://bagzpack.s3.amazonaws.com/logo/68ea80da-f61b-4333-a4ed-ebae07c63893/IMG/1645694302682.png"
                            alt="wowcarzlogo"
                            className="object-cover cursor-pointer"
                        />
                    </div>

                    <div className="flex items-center gap-3">
                        <a
                            href="/"
                            className="bg-blue-600 text-white px-4 py-2 rounded-lg shadow hover:bg-blue-700 transition"
                        >
                            Book Now
                        </a>
                        <a
                            href="tel:+919844300066"
                            className="inline-flex items-center gap-2 border border-gray-200 px-3 py-2 rounded-lg text-sm hover:bg-gray-100 transition"
                        >
                            📞 Call Us
                        </a>
                    </div>
                </div>
            </header>

            <main className="max-w-8xl mx-auto px-4 sm:px-6 lg:px-8 py-10">
                {/* Hero */}
                <section className="relative rounded-2xl h-[500px] sm:h-[550px] lg:h-[600px] overflow-hidden">

                    <img
                        src="/assets/tri.jpg"
                        alt="Self Drive Cars Chennai"
                        className="absolute inset-0 w-full h-full object-contain scale-125"
                    />
                    <div className="absolute inset-0 bg-black/50 flex flex-col justify-center items-center text-center px-6 sm:px-12 ">
                        <h2 className="text-3xl sm:text-5xl font-bold text-white mb-4 animate-fade-in">
                            Self Drive Cars in Trichy
                        </h2>

                        <p className="text-gray-200 text-base sm:text-lg mb-6 max-w-xl leading-relaxed">
                            Explore Mysore and nearby destinations with hassle-free self drive
                            cars from Wow Carz.
                        </p>
                    </div>

                </section>


                {/* Explore Section */}
                <section className="bg-gradient-to-r from-blue-50 via-indigo-50 to-purple-50 p-5 m-5">
                    <div className="max-w-4xl mx-auto bg-white shadow-lg rounded-3xl p-8 sm:p-12 text-center">
                        <h2 className="text-3xl sm:text-4xl font-bold text-gray-800 mb-6">
                            Explore Trichy with Wow Carz
                        </h2>
                        <p className="text-gray-700 text-base sm:text-lg leading-relaxed">
                            Discover Trichy in a way that feels effortless, elegant, and entirely your own. With <strong>Wow Carz</strong>, experience premium self drive car rentals designed for those who value comfort, freedom, and sophistication in every journey.

                            Whether it’s a serene drive through the city, an important business engagement, or a spontaneous weekend escape within 100 kms, our carefully maintained fleet ensures every ride feels smooth, refined, and reliable. No schedules. No compromises. Just the open road and complete control in your hands.

                            Travel isn’t just about reaching a destination — it’s about how you feel along the way. With Wow Carz, every journey becomes a statement of style, independence, and confidence.


                        </p>
                    </div>
                </section>

                {/* Why Rent Section (Slider) */}
                <section className="py-12 bg-gray-50">
                    <h2 className="text-3xl sm:text-4xl font-bold text-center mb-10 text-gray-900">
                        Why Rent With Wow Carz?
                    </h2>
                    <Slider {...sliderSettings} className="px-6 [&_.slick-dots]:left-0">
                        {whyCards.map((card, i) => (
                            <div key={i} className="px-3">
                                <div className="bg-white rounded-2xl shadow-lg p-6 text-center hover:shadow-xl transition">
                                    <h3 className="text-xl font-semibold mb-2">{card.title}</h3>
                                    <p className="text-gray-600 text-sm">{card.text}</p>
                                </div>
                            </div>
                        ))}
                    </Slider>
                </section>

                {/* Plan Your Trip */}
                <section className="py-12 sm:py-16 bg-blue-200 mx-4 sm:mx-8 lg:mx-16 rounded-2xl">
                    <div className="max-w-7xl mx-auto text-center px-4">

                        <h2 className="text-2xl sm:text-3xl lg:text-4xl font-bold mb-10 text-gray-900">
                            Plan Your Trip to Trichy
                        </h2>

                        <Slider {...sliderSettings} className="px-2">

                            {/* Card 1 */}
                            <div className="px-3">
                                <div className="bg-white p-6 sm:p-8 rounded-2xl shadow-md hover:shadow-xl transition duration-300">
                                    <div className="w-12 h-12 mx-auto mb-4 flex items-center justify-center rounded-full bg-purple-100 text-purple-600 text-2xl">
                                        🏛️
                                    </div>

                                    <h3 className="text-lg sm:text-xl font-semibold mb-3">
                                        Interesting Facts About Trichy
                                    </h3>

                                    <p className="text-gray-700 leading-relaxed text-sm sm:text-base">
                                        Tiruchirappalli, popularly known as Trichy, is one of the oldest cities in Tamil Nadu located on the banks of the Kaveri River. The city is famous for  Rockfort Temple and Sri Ranganathaswamy Temple in Srirangam.
                                    </p>
                                </div>
                            </div>

                            {/* Card 2 */}
                            <div className="px-3">
                                <div className="bg-white p-6 sm:p-8 rounded-2xl shadow-md hover:shadow-xl transition duration-300">
                                    <div className="w-12 h-12 mx-auto mb-4 flex items-center justify-center rounded-full bg-indigo-100 text-indigo-600 text-2xl">
                                        🏫
                                    </div>

                                    <h3 className="text-lg sm:text-xl font-semibold mb-3">
                                        Education & Cultural Hub
                                    </h3>

                                    <p className="text-gray-700 leading-relaxed text-sm sm:text-base">
                                        Trichy is an important education center in Tamil Nadu with reputed institutions like NIT Trichy, Bharathidasan University, and several engineering and arts colleges attracting students from across India.
                                    </p>
                                </div>
                            </div>

                            {/* Card 3 */}
                            <div className="px-3">
                                <div className="bg-white p-6 sm:p-8 rounded-2xl shadow-md hover:shadow-xl transition duration-300">
                                    <div className="w-12 h-12 mx-auto mb-4 flex items-center justify-center rounded-full bg-red-100 text-red-600 text-2xl">
                                        🎉
                                    </div>

                                    <h3 className="text-lg sm:text-xl font-semibold mb-3">
                                        Famous Festivals in Trichy
                                    </h3>

                                    <p className="text-gray-700 leading-relaxed text-sm sm:text-base">
                                        Major festivals celebrated in Trichy include Vaikunta Ekadasi at Srirangam Temple, Pongal, Navaratri, and the grand Chithirai Car Festival which attracts thousands of devotees every year.
                                    </p>
                                </div>
                            </div>

                            {/* Card 4 */}
                            <div className="px-3">
                                <div className="bg-white p-6 sm:p-8 rounded-2xl shadow-md hover:shadow-xl transition duration-300">
                                    <div className="w-12 h-12 mx-auto mb-4 flex items-center justify-center rounded-full bg-yellow-100 text-yellow-600 text-2xl">
                                        🌤️
                                    </div>

                                    <h3 className="text-lg sm:text-xl font-semibold mb-3">
                                        Best Time to Visit Trichy
                                    </h3>

                                    <p className="text-gray-700 leading-relaxed text-sm sm:text-base">
                                        The best time to visit Trichy is from July to March when the weather is pleasant for temple visits, sightseeing, and road trips to nearby destinations like Thanjavur, Kolli Hills, and Kodaikanal.
                                    </p>
                                </div>
                            </div>

                        </Slider>
                    </div>
                </section>

                {/* Near Places Section (Slider) */}
                <section className="mt-12">
                    <h3 className="text-2xl font-semibold text-gray-900 mb-2 text-center">
                        Places Near by Trichy
                    </h3>
                    <p className="text-gray-600 mb-6 text-center">
                        Perfect for day trips and weekend getaways with your Wow Carz ride.
                    </p>
                    <Slider {...sliderSettings} className="px-6 [&_.slick-dots]:left-0">
                        {nearplaces.map((place) => (
                            <div key={nearplaces.title} className="px-3">
                                <article className="bg-white rounded-2xl p-6 shadow-md hover:shadow-xl border border-gray-100 text-center transition">
                                    <img
                                        className="w-48 h-48 object-cover rounded-xl mx-auto mb-4"
                                        src={place.image}
                                        alt={place.title}
                                    />
                                    <h4 className="font-semibold text-lg mb-2">{place.title}</h4>
                                    <p className="text-gray-600 text-sm leading-relaxed">
                                        {place.desc}
                                    </p>
                                </article>
                            </div>
                        ))}
                    </Slider>
                </section>




                {/* Top Places */}
                <section className="mt-16">
                    <h3 className="text-2xl font-semibold text-gray-900 mb-2 text-center">
                        Top Places to Visit in and Around Trichy
                    </h3>
                    <p className="text-gray-600 mb-6 text-center">
                        Explore iconic landmarks, serene gardens, and historic towns with
                        your Wow Carz ride.
                    </p>
                    {/* Top place(PC view)*/}
                    <div className="hidden lg:grid grid-cols-3 gap-8 px-4 max-w-6xl mx-auto">
                        {places.map((place) => (
                            <div
                                key={place.title}
                                className="bg-white rounded-xl shadow-md hover:shadow-xl transition p-6 text-center"
                            >
                                <img
                                    src={place.image}
                                    alt={place.title}
                                    className="w-full h-56 object-cover rounded-lg mb-4"
                                />

                                <h4 className="text-xl font-semibold text-gray-900 mb-2">
                                    {place.title}
                                </h4>

                                <p className="text-gray-600 text-sm">
                                    {place.desc}
                                </p>
                            </div>
                        ))}
                    </div>
                    {/* Top place(Mobile view)*/}
                    <div className="block lg:hidden max-w-xl mx-auto">
                        <Slider {...sliderSettings}>
                            {places.map((place) => (
                                <div key={place.title} className="px-3">
                                    <div className="bg-white rounded-xl shadow-md p-6 text-center">

                                        <img
                                            src={place.image}
                                            alt={place.title}
                                            className="w-full h-52 object-cover rounded-lg mb-4"
                                        />

                                        <h4 className="text-lg font-semibold text-gray-900 mb-2">
                                            {place.title}
                                        </h4>

                                        <p className="text-gray-600 text-sm">
                                            {place.desc}
                                        </p>

                                    </div>
                                </div>
                            ))}
                        </Slider>
                    </div>

                </section>




                {/* FAQ */}
                <section className="mt-16">
                    <h3 className="text-2xl font-semibold text-gray-900 mb-4 text-center">
                        Frequently Asked Questions
                    </h3>
                    <div className="space-y-4">
                        {faqs.map((f, i) => (
                            <div
                                key={i}
                                className="border rounded-xl bg-white shadow-sm overflow-hidden"
                            >
                                <button
                                    onClick={() => setOpenFaq(openFaq === i ? null : i)}
                                    className="w-full text-left px-5 py-4 flex items-center justify-between hover:bg-gray-50 transition"
                                >
                                    <span className="font-medium text-gray-800">{f.q}</span>
                                    <span className="text-gray-500 text-lg">
                                        {openFaq === i ? "−" : "+"}
                                    </span>
                                </button>
                                <div
                                    className={`px-5 overflow-hidden transition-all duration-300 ${openFaq === i ? "max-h-40 py-3" : "max-h-0"
                                        }`}
                                >
                                    <p className="text-gray-700 text-sm leading-relaxed">{f.a}</p>
                                </div>
                            </div>
                        ))}
                    </div>
                </section>

                {/* CTA */}
                <section className="mt-16 bg-gradient-to-r from-blue-500 via-indigo-600 to-purple-600 text-white p-8 rounded-3xl flex flex-col sm:flex-row items-center justify-between gap-6">
                    <div className="text-center sm:text-left">
                        <h4 className="text-2xl font-semibold">
                            Ready to Start Your Journey?
                        </h4>
                        <p className="text-sm mt-2 text-blue-100">
                            Experience hassle-free driving with Wow Carz today.
                        </p>
                    </div>
                    <div className="flex gap-3">
                        <a
                            href="/"
                            className="bg-white text-blue-600 px-6 py-3 rounded-lg font-medium hover:bg-blue-100 transition"
                        >
                            Book Now
                        </a>
                        <a
                            href="tel:+919844300066"
                            className="border border-white px-6 py-3 rounded-lg hover:bg-white hover:text-blue-600 transition"
                        >
                            Call Us
                        </a>
                    </div>
                </section>

                {/* Footer */}
                <footer className="mt-10 text-center text-sm text-gray-500">
                    © {new Date().getFullYear()} Wow Carz — All rights reserved
                </footer>
            </main>
        </div>
    );
}

export default Trichy;
